import $http from '@vue-util/http';

type PopupMediaContent = Record<string, unknown> | { file_content: Record<string, unknown> };
type MediaContentRef = Ref<PopupMediaContent | null>;

type ToggleOverlay = (id: string) => unknown;

type PopupEvent = Event & { target?: HTMLAnchorElement | null };

export default function handlePopUpLink(mediacontent: MediaContentRef, toggle: ToggleOverlay) {
  return (e: PopupEvent) => {
    e.preventDefault();
    let reqUrl: string;
    const target = e.target;

    if (target?.href?.includes('popupFileName')) {
      const path = target.href.split('?')[1];
      reqUrl = `/shop/media/popup/?${path}&isAEM=true`;
    } else {
      const popupId = target?.href?.match(/popupOverlayId=(\d+)/)![1];
      reqUrl = `/shop/mediapopup?queryType=popup&popupID=${popupId}&isAEM=true`;
    }
    const linkText = target?.text || target?.textContent || '';
    target?.setAttribute('aria-label', `${linkText} link opens a modal dialog`);

    $http
      .get(reqUrl)
      .then((response: { data: { mediacontent?: Record<string, unknown> } & Record<string, unknown> }) => {
        mediacontent.value = target?.href?.includes('popupFileName')
          ? response.data.mediacontent || { file_content: response.data }
          : (response.data.mediacontent as Record<string, unknown>);
        toggle('popUpOverlay');
      })
      .catch((error: unknown) => {
        console.log(`Failed API request to: ${reqUrl}`, error);
      });
  };
}
